import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * /sysadmin/library — bare index. No content of its own; users always
 * land on a sub-tab. Documents is the primary surface post-X2 IA
 * convergence (articles + uploaded docs unify under one tab to mirror
 * tenant's Library Documents view).
 */
export const Route = createFileRoute('/sysadmin/library/')({
  beforeLoad: () => {
    throw redirect({ to: '/sysadmin/library/documents', replace: true });
  },
});
